import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorksSection from '../components/HowItWorksSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import CustomCursor from '../components/CustomCursor';
import useSEO from '../hooks/useSEO';

const HomePage = () => {
  // Define structured data for the home page
  const homePageSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "GLabs Automator",
    "description": "Chrome extension to automate content generation with Google Labs tools (ImageFX, Whisk, MusicFX, Flow) for bulk content creation. Perfect for stock contributors.",
    "applicationCategory": "Productivity, ContentCreation",
    "operatingSystem": "Chrome",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "156"
    }
  };

  // Apply SEO metadata
  useSEO({
    title: "GLabs Automator - Bulk Generate AI Content with Google Labs Tools",
    description: "Automate your AI content creation workflow with GLabs Automator. Generate images, text, music & videos in bulk using Google Labs' ImageFX, Whisk, MusicFX, and Flow (VEO3). Perfect for stock contributors & content creators.",
    keywords: "GLabs Automator, Google Labs Automation, bulk image generation, stock photography, AI content creation, Chrome extension, ImageFX, MusicFX, Whisk, Flow, VEO3",
    jsonLd: homePageSchema,
    openGraph: {
      image: "/src/assets/header/hero.png",
      type: "website"
    }
  });

  return (
    <div className="bg-gray-50 dark:bg-gray-900 transition-colors duration-300 overflow-x-hidden">
      
      {/* Custom Cursor */}
      <CustomCursor />
         
      {/* Navigation */}
      <Navigation />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Features Section */}
      <FeaturesSection />
      
      {/* How It Works Section */}
      <HowItWorksSection />
      
      {/* FAQ Section */}
      <FAQSection />
      
      {/* CTA Section */}
      <CTASection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
